import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const CustomSelect = ({
  className,
  isDisabled,
  isMandatory,
  markIfUnselected,
  maxMenuHeight = 160,
  name,
  showError,
  value,
  ...props
}) => {
  const [isVisited, setIsVisited] = useState(false);
  const shouldMarkRed =
    ((isMandatory && isVisited) || markIfUnselected) && !value && !isDisabled;

  const error = shouldMarkRed || showError;
  return (
    <Select
      onBlur={() => setIsVisited(true)}
      value={value}
      className={className}
      isDisabled={isDisabled}
      classNamePrefix={`select-${name}`}
      maxMenuHeight={maxMenuHeight}
      styles={{
        control: provided => ({
          ...provided,
          ...(error && {
            borderColor: 'red',
            outline: 'none',
            '&:hover': {
              borderColor: 'red',
            },
          }),
        }),

        menuList: provided => ({
          ...provided,
          '&::-webkit-scrollbar': {
            width: '4px !important',
            height: '6px',
            display: 'block !important',
            background: 'none',
          },
          '&::-webkit-scrollbar-track': {
            background: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#f17c7c',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#da6363',
          },
        }),
      }}
      {...props}
    />
  );
};

CustomSelect.propTypes = {
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isMandatory: PropTypes.bool,
  markIfUnselected: PropTypes.bool,
  maxMenuHeight: PropTypes.number,
  name: PropTypes.string,
  showError: PropTypes.bool,
  value: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
};

export default CustomSelect;
